import styled from "styled-components";

export const MacroTypeSwitcherContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ numberOfColumns }) =>
    `repeat(${numberOfColumns}, minmax(55px, 124px))`};
  justify-content: space-between;
  grid-gap: 10px;
`;

export const MacroTypeSwitch = styled.div`
  background-color: ${({ isSelected }) => (isSelected ? "#07145a" : "#ffffff")};
  height: 32px;
  min-width: 55px;
  color: ${({ isSelected }) => (isSelected ? "#ffffff" : "#07145a")};
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 3px;
  line-height: 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
`;

export const TextEditorContainer = styled.div`
  margin-top: 20px;

  & > div:nth-child(2) {
    border-color: ${({ borderColor }) => borderColor};

    .text-options-wrapper {
      background-color: ${({ backgroundColor }) => backgroundColor};
    }

    .icon-container {
      svg {
        color: ${({ actionsColor }) => actionsColor};
      }
    }

    svg.border {
      path {
        stroke: ${({ dividerColor }) => dividerColor};
      }
    }
  }
`;

export const TemplateLibraryContainer = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #42526e;
  margin-top: 20px;
  padding-bottom: 20px;
  cursor: pointer;
  gap: 12px;

  #arrow-right-icon {
    visibility: hidden;
  }

  &:hover {
    #arrow-right-icon {
      visibility: visible;
    }
  }
`;

export const IconLabelContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
  margin-left: 18px;
`;

export const FieldContainer = styled.div`
  display: ${({ isHidden }) => (isHidden ? "none" : "block")};
  margin-top: 20px;
`;

export const FieldLabel = styled.div`
  font-size: 14px;
  color: #07145a;
  margin: 0 0 5px 0;
`;

export const GrayFieldLabel = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #6b778c;
  margin-bottom: 5px;
`;

export const FormFieldLabel = styled.div`
  color: #07145a;
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 8px 0;
`;

export const FormFieldDescription = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin-top: 5px;
  color: #6b778c;
`;

export const SelectedItemPanel = styled.div`
  border-radius: 4px;
  padding: 15px 20px;
  background: ${({ bg }) => bg};
`;

export const SelectedItemPanelLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #6b778c;
`;
